<template>
  <div>
    <px-view-header title="Unidades de Medida" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-unidades-medida-list-header :on-click-refresh="onClickRefresh"
                                    :on-change-filter="onChangeFilter" />
    <px-unidades-medida-list :unidadesMedidas="unidadesMedidas"
                             :loading="loading"
                             :on-change-options="onChangeOptions"
                             :options-list="optionsList"
                             @remove="onRemove" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import UnidadesMedidaService from './unidades-medida-service';
import UnidadesMedidaList from './UnidadesMedidaList.vue';
import UnidadesMedidaListHeader from './UnidadesMedidaListHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Produto' },
        { text: 'Unidades de Medida' },
      ],
      unidadesMedidas: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: 'entidade is not null',
        sort: 'descricao',
        sortDesc: false,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemUnidadesMedida', ['stringFilter']),
  },
  methods: {
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getUnidadesMedida();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getUnidadesMedida();
    },
    onClickRefresh() {
      this.getUnidadesMedida();
    },
    onRemove(item) {
      this.loading = true;
      UnidadesMedidaService.remover(item.id)
        .then(() => {
          this.$toast('Unidade de medida removida com sucesso', { color: 'success' });
          this.getUnidadesMedida();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getUnidadesMedida() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return UnidadesMedidaService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.unidadesMedidas = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
  components: {
    pxUnidadesMedidaList: UnidadesMedidaList,
    pxUnidadesMedidaListHeader: UnidadesMedidaListHeader,
  },
};

</script>
